<template>
  <div>
    <!-- <van-nav-bar title="报名" /> -->
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>{{ meetingName }}</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm">
		<h3 class="bmlcTit">填写参会人信息 <van-icon class="iconfont" class-prefix="icon" name="bianji" size="24" color="#e5b91c" /></h3>
      <van-col span="24">
        <van-form @submit="onSubmit">
          <div class="formInput hide"><van-field v-model="meetingId" name="meetingId" label="id" /></div>
          <div class="formInput " v-for="(item, key, index) in formData" v-if="item.isShow * 1 == 1 && item.formType * 1 == 1">
              <van-field
                v-model="item[key]"
                :name="item.shortName"
                :ref="item.shortName"
                :placeholder="`请输入` + item.name"
                :label="item.name"
                clearable
                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                :required="JSON.parse(item.defaultValue).rules&&JSON.parse(item.defaultValue).rules.length==0 ? false : true"
                v-if="item.shortName !== 'phone'&&item.shortName !== 'ReAddress'"
              />
              <div v-else-if="item.shortName == 'ReAddress'">
                <div class="formInput " style="margin:0;">
                <van-field
                  readonly
                  clickable
                  is-link
                  :name="item.shortName"
                  :value="ReAddressValue"
                  :label="item.name"
                  :placeholder="`点击选择地区`"
                  @click="showPickerSsx = true"
                  :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                  :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
                />
                <van-popup v-model="showPickerSsx" position="bottom">
                  <van-area title="标题" :area-list="areaList" @confirm="confirmFn" @cancel="ReAddressShow = false" />
                </van-popup>
                </div>
                <van-field
                  v-model="item[key]"
                  :name="item.shortName"
                  :ref="item.shortName"
                  placeholder="请输入详细地址（涉及疫情防控,非常重要!）"
                  clearable
                  :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                />
              </div>

              <van-field
                @blur="phoneBlur"
                @input="phoneInput"
                v-model="item[key]"
                :name="item.shortName"
                :ref="item.shortName"
                :placeholder="`请输入` + item.name"
                :label="item.name"
                clearable
                maxlength="11"
                type="tel"
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
                :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: JSON.parse(item.defaultValue).rules[0] !== undefined ? true : false, message: '请输入正确'+ item.name }]"
                v-else
              />

          </div>
          <div class="formInput " v-for="(item, key, index) in formData" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 1 && item.shortName == 'email'">
            <van-field
              v-model="item[key]"
              :name="item.shortName"
              :ref="item.shortName"
              :placeholder="`请输入` + item.name"
              :label="item.name"
              clearable
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
              :rules="[{ pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required: JSON.parse(item.defaultValue).rules[0] !== undefined ? true : false, message: '请输入正确'+ item.name }]"
            />
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'isVisit'">
            <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-radio-group v-model="isVisit" direction="horizontal">
                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'sex'">
            <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-radio-group v-model="sexValue" direction="horizontal">
                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="formInputs" v-else-if="item.isShow * 1 == 1 && item.shortName == 'isYdjd'">
            <div class="formInput">
            <!-- <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-radio-group v-model="isYdjdValue" direction="horizontal">
                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
                </van-radio-group>
              </template>
            </van-field> -->
              <van-field
                readonly
                clickable
                :name="item.shortName"
                :value="isYdjdValue"
                :label="item.name"
                :placeholder="`点击选择` + item.name"
                @click="showPicker_isYdjd = true"
                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
              />
              <van-popup v-model="showPicker_isYdjd" position="bottom">
                <van-picker show-toolbar :columns="isYdjdColumns" @confirm="onConfirmIsYdjd" @cancel="showPicker_isYdjd = false" />
              </van-popup>
            </div>
            <div v-if="isYdjdValue=='是'">
              <div v-for="zItem,index in item.linkage" :key="index">
                <div class="formInput" v-if="zItem.isShow * 1 == 1 && zItem.formType * 1 == 3 ">
                  <van-field
                    readonly
                    clickable
                    :name="zItem.shortName"
                    :value="fangxingValue"
                    :label="zItem.name"
                    :placeholder="`点击选择` + zItem.name"
                    @click="showPickerFangxing = true"
                    :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                    :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
                  />
                  <van-popup v-model="showPickerFangxing" position="bottom">
                    <van-picker show-toolbar :columns="fangxingColumns" @confirm="onConfirmFangxing" @cancel="showPickerFangxing = false" />
                  </van-popup>
                </div>
                <div class="formInput " v-else-if="zItem.isShow * 1 == 1 && zItem.formType * 1 == 6">
                  <van-field
                    readonly
                    clickable
                    :name="zItem.shortName"
                    :value="rzldTime"
                    :label="zItem.name"
                    :placeholder="`点击选择` + zItem.name"
                    @click="showRzld=true"
                    :rules="[JSON.parse(zItem.defaultValue).rules[0] !== undefined ? JSON.parse(zItem.defaultValue).rules[0] : '']"
                    :required="JSON.parse(zItem.defaultValue).rules == '' ? false : true"
                  />
                    <van-calendar v-model="showRzld" type="range" @confirm="onConfirmRzldDate" :show-confirm="false" :min-date="rzldMinDate" :max-date="rzldMaxDate" />
                </div>
              </div>

            </div>
          </div>


          <div class="formInputs" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'zjlx'">
          <div class="formInput">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="zjlxValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerZjlx = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerZjlx" position="bottom">
              <van-picker show-toolbar :columns="zjlxColumns" @confirm="onConfirmZjlx" @cancel="showPickerZjlx = false" />
            </van-popup>
            <!-- <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-radio-group v-model="zjlxValue" direction="horizontal">
                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
                </van-radio-group>
              </template>
            </van-field> -->
          </div>
            <div class="formInput" v-if="zjlxValue == '身份证'">
              <van-field
                v-model="cardNum"
                name="cardNum"
                placeholder="请输入证件号码"
                label="证件号码"
                clearable
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
                :rules="[{ pattern: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[xX])$/, message: '请输入正确身份证号'}]"
              />
            </div>
            <div class="formInput" v-else-if="zjlxValue == '军官证'">
              <van-field
                v-model="officer"
                name="officer"
                placeholder="请输入证件号码"
                label="证件号码"
                clearable
                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
              />
            </div>
            <div class="formInput" v-else-if="zjlxValue == '港澳通行证'">
              <van-field
                v-model="HKMpass"
                name="HKMpass"
                placeholder="请输入证件号码"
                label="证件号码"
                clearable
                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
              />
            </div>
            <div class="formInput" v-else-if="zjlxValue == '护照'">
              <van-field
                v-model="passport"
                name="passport"
                placeholder="请输入证件号码"
                label="证件号码"
                clearable
                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
              />
            </div>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'province'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="provinceValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPicker = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker show-toolbar :columns="provinceColumns" @confirm="onConfirmProvince" @cancel="showPicker = false" />
            </van-popup>
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'zzmm'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="zzmmValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerZzmm = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerZzmm" position="bottom">
              <van-picker show-toolbar :columns="zzmmColumns" @confirm="onConfirmZzmm" @cancel="showPickerZzmm = false" />
            </van-popup>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'nation'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="nationValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerNation = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerNation" position="bottom">
              <van-picker show-toolbar :columns="nationColumns" @confirm="onConfirmNation" @cancel="showPickerNation = false" />
            </van-popup>
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'education'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="educationValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerEducation = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerEducation" position="bottom">
              <van-picker show-toolbar :columns="educationColumns" @confirm="onConfirmEducation" @cancel="showPickerEducation = false" />
            </van-popup>
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'shens'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="shensValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerShens = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerShens" position="bottom">
              <van-area title="标题" :area-list="areaList" :columns-num="2" @confirm="onConfirmShens" @cancel="showPickerShens = false" />
            </van-popup>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'ssjg'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="ssjgValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPickerSsjg = true"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model="showPickerSsjg" position="bottom">
              <van-picker show-toolbar :columns="ssjgColumns" @confirm="onConfirmSsjg" @cancel="showPickerSsjg = false" />
            </van-popup>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 5 && item.shortName == 'bmtable'">
            <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-uploader v-model="fileList" :deletable="false" accept="image/*,application/pdf" :max-size="5000 * 1024" :after-read="afterRead" />

              </template>
            </van-field>
            <p style="color:red; text-align: center;"><b>仅支持pdf、图片格式</b></p>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'csrq'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="dateValue"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPopup"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model:show="show" position="bottom">
              <van-datetime-picker
              v-model="showCalendar"
              @confirm="onConfirmDate"
              @cancel="onCancelDate"
              :min-date="minDate"
              :max-date="maxDate"
                type="date"
                title="选择年月日"
              />
            </van-popup>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'djsj'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="djsj"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPopup_djsj"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model:show="show_djsj" position="bottom">
              <van-datetime-picker
              v-model="showCalendar"
              @confirm="onConfirmDate_djsj"
              @cancel="onCancelDate"
                :min-date="maxDate"
                type="date"
                title="选择年月日"
              />
            </van-popup>
          </div>
          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'fjsj'">
            <van-field
              readonly
              clickable
              :name="item.shortName"
              :value="fjsj"
              :label="item.name"
              :placeholder="`点击选择` + item.name"
              @click="showPopup_fjsj"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            />
            <van-popup v-model:show="show_fjsj" position="bottom">
              <van-datetime-picker
              v-model="showCalendar"
              @confirm="onConfirmDate_fjsj"
              @cancel="onCancelDate"
                :min-date="maxDate"
                type="date"
                title="选择年月日"
              />
            </van-popup>
          </div>
          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'isBase'">
            <van-field
              :name="item.shortName"
              :label="item.name"
              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
            >
              <template #input>
                <van-radio-group v-model="isBaseValue" direction="horizontal">
                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div style="margin:30px 16px 16px;">
            <van-button round block :disabled="disabled" type="info" native-type="submit">{{ submitBtn == -1 ? '会议已结束' : submitBtn == 0 ? '提交' : '下一步' }}</van-button>
          </div>
        </van-form>
        <!-- <div class="jdydBz">
            <h3>广东省卫健行业网络安全培训班住宿房间预订统计</h3>
            <p>本次培训可预订酒店，本次统计主要用于预留房间，费用需自理。默认每个报名名额预订一间（标间/单间），如需多人请分别填写</p>
            <p>注：</p>
            <p>酒店地址：佛山市南海新湖大酒店</p>
            <p>豪华双人房：酒店协议价248元/间</p>
            <p>豪华单人房：酒店协议价248元/间</p>
        </div> -->
        <div style="text-align: right;padding:20px;"><a style="color:#1e51c7;" @click="grzxLink">已报名？点击查看报名详情</a></div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import moment from 'moment';
const myImage = new Image();
var formData = new FormData();
export default {
  data() {
    return {
      meetingName: this.$cookies.get('meetingName'),
      sexValue: '男',
      isVisit:'是',
      isYdjdValue:'',
      isYdjdColumns:[],
      isYdjdValueEnum:[],
      showPicker_isYdjd: false,
      isBaseValue:'是',
      zjlxValue: '',
      cardNum:'',
      officer:'',
      HKMpass:'',
      passport:'',
      code: '',
      sjhm: '',
      isClick: true,
      time: '获取验证码',
      submitBtn: '', //0 非审核-免费会议  1 非审核收费会议  2 审核-免费会议
      formData: '',
      zjlxValue: '',
      zjlxColumns:[],
      ssjgValue: '',
      ssjgColumns:[],
      provinceValue: '',
      provinceColumns: [],
      zzmmValue: '',
      zzmmColumns: [],
      nationValue: '',
      nationColumns: [],
      educationValue: '',
      educationColumns: [],
      shensValue: '',
      showPickerZjlx: false,
      showPicker: false,
      showPickerShens: false,
      showPickerZzmm: false,
      showPickerNation: false,
      showPickerEducation: false,
      showPickerSsjg: false,
      dateValue: '',
      showCalendar: false,
      zjlxValueEnum:[],
      ssjgValueEnum:[],
      valueEnum: [],
      zzmmValueEnum: [],
      nationValueEnum: [],
      educationValueEnum: [],
      meetingId: '',
      disabled: false,
      areaList: areaList,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      show:false,
      phoneValue:"",
      fileList:[],
      bmtable:[],
      ReAddressShow:false,
      showPickerSsx:false,
      ReAddressValue:'',
      provinceSelect:'',
      citySelect:'',
      districtSelect:'',
      //房型
      showPickerFangxing: false,
      fangxingValue: '',
      fangxingColumns:[],
      fangxingValueEnum:[],
      //入住/离店时间
      showRzld: false,
      rzldValue:'',
      rzldTime:'',
      rzldStartTime:'',
      rzldEndTime:'',
      rzldMinDate: '',
      rzldMaxDate: '',
      show_djsj:false,
      show_fjsj:false,
      djsj:'',
      fjsj:''
    };
  },
  created() {
    this.meetingCode();
    this.getMeetingFromInfo();
  },
  methods: {
    confirmFn(value) {
        this.ReAddressValue = value.map(item => item.name).join('/');
        this.provinceSelect = value[0].name;
        this.citySelect = value[1].name;
        this.districtSelect = value[2].name;
        this.showPickerSsx = false;
    },
    afterRead(file){
      const formData = new FormData();
      console.log(file.file);
      if (file.file) {
        file.status = 'uploading';
        file.message = '上传中...';
        formData.append("file",file.file);
        this.axios.post('/api/appweb/appThesis/uplaod',formData).then(res=>{
          console.log(res.data.status);
          if(res.data.status == 200){
            file.status = '';
            file.message = '';
            this.bmtable.push(res.data.data);
          }
        })
      } else if (file.length > 1){
        var fileArr = file;
        for (let index in fileArr) {
          fileArr[index].status = 'uploading';
          fileArr[index].message = '上传中...';
          formData.append("file",fileArr[index].file);
          this.axios.post('/api/appweb/appThesis/uplaod',formData).then(res=>{
            console.log(res);
            if(res.data.status == 200){
              fileArr[index].status = '';
              fileArr[index].message = '';
              this.bmtable.push(res.data.data);
            }
          })
        }
      }
    },
    grzxLink(){
      this.$router.push('/personal/login?meetingId='+this.meetingId)
    },
    phoneInput(value){
      this.phoneValue = value;
    },
    phoneBlur(){
        this.axios.get('/api/appweb/entered/getEnteredByPhone/'+this.meetingId+'/'+this.phoneValue).then(res=>{
          var data = res.data.data;
          if(data.code == -1){
            this.$toast.fail(data.message);
            this.disabled = true;
            return false;
          }
          this.disabled = false;
        })
    },
    /**
     * 获取URL参数
     * @returns {Object}
     */
    getUrlCode(){
        var url = location.search
        var theRequest = new Object()
        if (url.indexOf("?") != -1){
            var str = url.substr(1)
            var strs = str.split("&")
            for(var i = 0; i < strs.length; i ++){
                theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
            }
        }
        return theRequest
    },
    showPopup(){
      this.ReAddressShow = true
    },
    showPopup_djsj(){
      this.show_djsj = true;
    },
    showPopup_fjsj(){
      this.show_fjsj = true;
    },
    onCancelDate(){
      this.show = false;
      this.show_djsj = false;
      this.show_fjsj = false;
    },
    onConfirmDate(date) {
      var Year = date.getFullYear();
      var Month = date.getMonth()+1;
      if(Month<10){
        var Month = '0'+`${date.getMonth()+1}`;
      }
      var Dates = date.getDate();
      if(Dates<10){
        var Dates = '0'+date.getDate();
      }
      this.dateValue = `${Year}-${Month}-${Dates}`;
      this.show = false;
    },
    onConfirmDate_djsj(date) {
      var Year = date.getFullYear();
      var Month = date.getMonth()+1;
      if(Month<10){
        var Month = '0'+`${date.getMonth()+1}`;
      }
      var Dates = date.getDate();
      if(Dates<10){
        var Dates = '0'+date.getDate();
      }
      this.djsj = `${Year}-${Month}-${Dates}`;
      this.show_djsj = false;
    },
    onConfirmDate_fjsj(date) {
      var Year = date.getFullYear();
      var Month = date.getMonth()+1;
      if(Month<10){
        var Month = '0'+`${date.getMonth()+1}`;
      }
      var Dates = date.getDate();
      if(Dates<10){
        var Dates = '0'+date.getDate();
      }
      this.fjsj = `${Year}-${Month}-${Dates}`;
      this.show_fjsj = false;
    },
    onConfirmZjlx(value) {
      this.zjlxValue = value;
      this.showPickerZjlx = false;
    },
    onConfirmSsjg(value) {
      this.ssjgValue = value;
      this.showPickerSsjg = false;
    },
    onConfirmProvince(value) {
      this.provinceValue = value;
      this.showPicker = false;
    },
    onConfirmZzmm(value) {
      this.zzmmValue = value;
      this.showPickerZzmm = false;
    },
    onConfirmNation(value) {
      this.nationValue = value;
      this.showPickerNation = false;
    },
    onConfirmEducation(value) {
      this.educationValue = value;
      this.showPickerEducation = false;
    },
    onConfirmShens(value) {
      // console.log(this.shensValue);
      this.shensValue = value.map(item => item.name).join('/');
      this.showPickerShens = false;
    },
    //房型
    onConfirmFangxing(value) {
      this.fangxingValue = value;
      this.showPickerFangxing = false;
    },
    //是否入住酒店
    onConfirmIsYdjd(value) {
      this.isYdjdValue = value;
      this.showPicker_isYdjd = false;
    },
    //入住离店时间
    onConfirmRzldDate(date) {
      this.showRzld = false;
      const [start, end] = date;
      this.rzldTime = `${this.$moment(start).format('YYYY-MM-DD')} 至 ${this.$moment(end).format('YYYY-MM-DD')}`;
      this.rzldStartTime = this.$moment(start).format('YYYY-MM-DD');
      this.rzldEndTime = this.$moment(end).format('YYYY-MM-DD');
    },
    onClickLeft() {
      this.$router.go(-1); //返回上一层
    },
    // 获取验证码
    gainCode() {
      if (this.isClick) {
        if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.sjhm)) {
          this.axios.get('/api/appweb/login/sendEnteredAddMessage/' + this.sjhm+'?meetingId='+this.meetingId).then(res => {
            let data = res.data;
            // console.log(res.data)
            if (data.status == 200) {
              this.$toast.success(data.message);
            }
          });
          this.isClick = false;
          let s = 60;
          this.time = s + '秒';
          let interval = setInterval(() => {
            s--;
            this.time = s + '秒';
            if (s < 0) {
              this.time = '重新获取';
              this.isClick = true;
              clearInterval(interval);
            }
          }, 1000);
        } else {
          this.$toast.fail('请输入正确的手机号码');
        }
      }
    },
    onSubmit(values) {
      console.log(values);
      // return false
      this.disabled = true;
      // debugger
      var bmtableArr = this.bmtable;
      if(bmtableArr.length>0){
        var bmtable = '';
        for (let index in bmtableArr) {
           bmtable += bmtableArr[index]+',';
        }
        bmtable = bmtable.substring(0,bmtable.length - 1);
        values.bmtable = bmtable;
      }
      if(values.provinceSelect){
        values.provinceSelect = this.provinceSelect;
      }
      if(values.citySelect){
        values.citySelect = this.citySelect;
      }
      if(values.districtSelect){
        values.districtSelect = this.districtSelect;
      }
      if(values.rzldTime){
        values.rzldStartTime = this.rzldStartTime;
        values.rzldEndTime = this.rzldEndTime;
      }
      if(values.phone){
        this.axios.get('/api/appweb/entered/getEnteredByPhone/'+this.meetingId+'/'+values.phone).then(res=>{
          var data = res.data.data;
          // console.log(data);
          if(data.code == -1){
            this.$toast.fail(data.message);
            return false;
          }else{
            for (var i in this.provinceValueEnum) {
              if (values.province == this.provinceValueEnum[i].text) {
                values.province = i;
              }
            }
            // var values = JSON.stringify(values);
            console.log('submit', values);
            sessionStorage.setItem('values',JSON.stringify(values));
            if (this.$cookies.get('cookie_entret_type') == '2') {
              sessionStorage.setItem('phone',values.phone);
			  if(this.$cookies.get('cookies_entret_isScore')  == '1'){
				this.$router.push('/Wyxf/index?meetingCode='+this.$route.query.meetingCode);
			  }else{
			  	this.$router.push('/Fpgl/index?meetingCode='+this.$route.query.meetingCode);
			  }
            }else{
              this.axios.post('/api/appweb/entered/fromAdd', values).then(res => {
                if (res.data.status == 200) {
                    localStorage.clear();
                    this.$toast.success('报名成功');
                    this.$router.push('/free/index');
                } else {
                  this.disabled = false;
                  if (res.data.msg) {
                    this.$toast.fail(res.data.msg);
                  } else if(res.data.status == -1){
                    this.$toast.fail(res.data.message);
                  }
                  else {
                    this.$toast.fail(res.data.result.users[0].msg);
                  }
                }
              })
            }
          }
        })
      }


    },
    //获取会议code
    meetingCode() {
      var meetingCode = this.$route.query.meetingCode;
      // console.log(meetingCode);
      if (meetingCode == '' || meetingCode == undefined || meetingCode == null) {
        this.$toast.fail('缺少会议code');
        return false;
      }
      this.axios.get('/api/appweb/appMeeting/getMeetingBycode/' + meetingCode).then(res => {
        let data = res.data.data;
        if (res.data.status == 200) {
          this.meetingId = data.id;
          var timestamp = Date.parse(new Date());
		  var bmEndTime = moment(data.bmEndTime).format('YYYY-MM-DD')+' 23:59:59';
		  if (moment(bmEndTime).valueOf() < timestamp) {
              this.submitBtn = -1;
              this.disabled = true;
              this.$dialog.alert({
                message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
              });
          }
          if (data.isBmf * 1 == 1) {
            this.submitBtn = '2';
            var cookie_entret_type = this.$cookies.get('cookie_entret_type');
            console.log(cookie_entret_type)
            if (cookie_entret_type == '7') {
              this.submitBtn = '0';
            } else{
              this.submitBtn = '1';
            }
          }else{
            this.submitBtn = '0';
          }

        }
      });
    },
    //会议是否结束
    isMeetingEnd() {
      // console.log(this.$data.meetingId);
      this.axios.get('/api/appweb/entered/isMeetingEnd/' + this.meetingId).then(res => {
        if (res.data.status !== 200) {
          this.submitBtn = -1;
          this.disabled = true;
          this.$dialog.alert({
            message: res.data.message
          });
        }
      });
    },
    //获取会议信息
    getMeetingFromInfo() {
      var meetingCode = this.$route.query.meetingCode;
      var html = '';
      this.axios.get('/api/appweb/entered/getMeetingFromInfo?code=' + meetingCode).then(res => {
        let meetingForm = res.data.data.meetingForm;
        //入住/离店时间：报名开始前一天到报名结束日期
        this.rzldMinDate = new Date(this.$moment(res.data.data.startTime).format('YYYY'),this.$moment(res.data.data.startTime).format('M')-1,this.$moment(res.data.data.startTime).format('D')*1-1);
        this.rzldMaxDate = new Date(this.$moment(res.data.data.endTime).format('YYYY'),this.$moment(res.data.data.endTime).format('M')-1,this.$moment(res.data.data.endTime).format('D'));
        sessionStorage.setItem('meetingId',res.data.data.meeting.id);
        //免费隐藏字段：会议酒店住宿需求（牡丹港都）、抵达时间、返程时间、是否参加24日医院参观
        if(this.$cookies.get('cookie_entret_type') == '7'&&meetingCode=='tiboltto'){
            var meetingForm_mf = [];
            meetingForm.forEach((v,key,index)=>{
              if(v.shortName!="isYdjd"&&v.shortName!="djsj"&&v.shortName!="fjsj"&&v.shortName!="isVisit"){
                meetingForm_mf.push(v)
              }
            })
            meetingForm = meetingForm_mf;
        }
        //免费隐藏字段结束

        meetingForm.forEach((item, key, index) => {
          let valueEnum = JSON.parse(item.defaultValue).valueEnum;
          if (item.shortName == 'zjlx') {
            this.zjlxValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.zjlxColumns.push(valueEnum[i].text);
            }
          } if (item.shortName == 'province') {
            this.provinceValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.provinceColumns.push(valueEnum[i].text);
            }
          } if (item.shortName == 'isYdjd') {
            this.isYdjdValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.isYdjdColumns.push(valueEnum[i].text);
            }
          } else if (item.shortName == 'zzmm') {
            this.zzmmValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.zzmmColumns.push(valueEnum[i].text);
            }
          } else if (item.shortName == 'nation') {
            this.nationValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.nationColumns.push(valueEnum[i].text);
            }
          } else if (item.shortName == 'education') {
            this.educationValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.educationColumns.push(valueEnum[i].text);
            }
          }else if (item.shortName == 'ssjg') {
            this.ssjgValueEnum = valueEnum;
            for (var i in valueEnum) {
              this.ssjgColumns.push(valueEnum[i].text);
            }
          }else if (item.shortName == 'isYdjd') {
            console.log(item);
             item.linkage = [
               // {
               //   "isCommon": "1",
               //   "shortName": "fangXing",
               //   "name": "房型",
               //   "isShow": "1",
               //   "type": "CHAR",
               //   "formType": "3",
               //   "defaultValue": "{\"title\":\"房型\",\"dataIndex\":\"fangXing\",\"rules\":[{\"required\":true,\"message\":\"必填项\"}],\"valueEnum\":{\"单间\":{\"text\":\"单间\"},\"标间\":{\"text\":\"标间\"}},\"hideInSearch\":true}"
               //  },
               //  {
               //    "isCommon": "1",
               //    "shortName": "rzldTime",
               //    "name": "入住/离店时间",
               //    "isShow": "1",
               //    "type": "dateRange",
               //    "formType": "6",
               //    "defaultValue": "{\"title\":\"入住/离店时间\",\"dataIndex\":\"rzldTime\",\"valueType\":\"dateRange\",\"rules\":[{\"required\":true,\"message\":\"必填项\"}],\"hideInSearch\":true}"
               //  }
             ];
             var linkage = item.linkage;
             for (var i = 0; i < linkage.length; i++) {
               let ydjdValueEnum = JSON.parse(linkage[i].defaultValue).valueEnum;
               if(linkage[i].shortName == 'fangXing'){
                 this.fangxingValueEnum = ydjdValueEnum;
                 for (var i in ydjdValueEnum) {
                   this.fangxingColumns.push(ydjdValueEnum[i].text);
                 }
               }
             }
          }
        });
        this.formData = meetingForm;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bmlcTit {
	font-size: 20px;
	font-weight: bold;
	margin-top: 0;
	margin-bottom: 20px;
	margin-left: 20px;
	color: #0038b8;
}
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 10px 20px 30px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size:  100% 100%;
  color:#fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  font-size: 30px;
}
.hide {
  display: none;
}
.formInput {
  padding: 4px 0;
  margin:0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd{
  height:3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
.van-cell,.van-button{
  font-size: 16px;
}
.van-cell::after{
  border-bottom: 0;
}
.jdydBz{background-color: #f8f8f8;margin:0 3%;padding:10px;border-radius: 6px;}
.jdydBz h3{ text-align: center;font-size: 16px;font-weight: bold;padding: 10px 0;margin:0;}
.jdydBz p{ text-align: justify;font-size: 14px;margin: 0;line-height: 32px;color:#666;}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue